import { combineReducers } from 'redux';
import ama from './ama';
import user from './user';
import salesforce from './salesforce';
import vf1 from './visitForm1';
import vf2 from './visitForm2';

export const makeRootReducer = asyncReducers => combineReducers({
    room: ama,
    user,
    salesforce,
    vf1,
    vf2,
    ...asyncReducers,
});

export const injectReducer = (store, { key, reducer }) => {
    store.asyncReducers[key] = reducer;
    store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;
